import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../utils/axios";

const initialState = {
  loading: false,
  pointsTransferData: {},
  error: "",
  success: false,
  status: "",
};

const pointsTransferCall = createAsyncThunk(
  "post/points-transfer",
  async ({ data }) => {
    try {
      const result = await axios.post(
        "https://apac.api.capillarytech.com/mobile/v2/api/points/transfer",
        data
      );

      return result?.data;
    } catch (err) {
      console.log(err);
    }
  }
);

const pointsTransferSlice = createSlice({
  name: "pointsTransfer",
  initialState,
  reducers: {
    reset: (state, payload) => {
      state.loading = false;
      state.success = false;
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(pointsTransferCall.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(pointsTransferCall.fulfilled, (state, action) => {

      state.loading = false;
      state.pointsTransferData = action.payload;
      state.success = action.payload?.errors?.length > 0 ? false : true;
      state.error =
        action.payload?.errors?.length > 0
          ? action.payload?.errors[0]?.message
          : "";
    });
    builder.addCase(pointsTransferCall.rejected, (state, action) => {
      state.loading = false;
      state.pointsTransferData = {};
      state.error = action.error.message;
      state.success = false;
    });
  },
});

export default pointsTransferSlice.reducer;
export const { reset } = pointsTransferSlice.actions;
export { pointsTransferCall };
